module.exports = __webpack_public_path__ + "img/get_web.2f32ce50.png";